import { storeConstants } from '@utils/constants';
import factory from '@helpers/storeFactories/factory';

import { apiServiceBmtCancellations } from '@api';
import normalize from '@/data/response/normalizeReportBmtCancellations';

const STORE_NAME = 'bmtCancellations';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceBmtCancellations.bmtCancellations.get,
    },
    {
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 99,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalize,
    }
);

export default store;
